import { render } from "./TipsHeteroatoms.vue?vue&type=template&id=5aaf6cc4"
import script from "./TipsHeteroatoms.vue?vue&type=script&lang=js"
export * from "./TipsHeteroatoms.vue?vue&type=script&lang=js"
script.render = render

export default script